/** @format */

import { ComponentType, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import ErrorBoundary from "../../api/ErrorBoundary";
import { useAuthHooks } from "../../hooks/useAuthHooks";
import useGTMHooks from "../../hooks/useGTMHooks";
import { Context } from "../../stores/Provider";

const BeforeRender = ({ Component, IsLoggedIn = true }: { Component: ComponentType<any>; IsLoggedIn?: boolean }) => {
  const { state } = useContext(Context);
  const location = useLocation();
  const { isAuthState, isDirectState, checkUserAuth, checkDirectAccess } = useAuthHooks(IsLoggedIn);
  const { pushDataLayerHandler } = useGTMHooks();

  useEffect(() => {
    pushDataLayerHandler();
    if (IsLoggedIn) {
      checkUserAuth();
      checkDirectAccess();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, state.agentPath, state.zAccount]);

  if (IsLoggedIn && !isAuthState && !isDirectState) {
    return null;
  }

  return (
    <ErrorBoundary>
      <Component />
    </ErrorBoundary>
  );
};

export default BeforeRender;
